import moment from 'moment/min/moment-with-locales'
import store from './store';
import { getTypeFromUrl } from './utils';
import * as VM from '@/viewModel'

let filters = {

    date(value: any, _format: string = "YYYY MMMM DD") {
        if (!value) return '---'

        value = value!

        let format = 'DD/MM/YYYY HH:mm'

        if (_format) format = _format

        const language = store.state.user.preferredCulture

        return moment.utc(value).local().locale(language).format(format)
    },

    academyDuration(value: number){
        var minuti = parseInt(<any>(value / 60));
        var secondi = Math.round(((value / 60) - minuti) * 60);
        return minuti + '’ ' + secondi + '”';
    },

    currency(value: any, decimals: number) {
        if(!decimals && decimals != 0)
            decimals = 2;
        if (value || value == 0) {
            let val = (value/1).toFixed(decimals).replace('.', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        }
    },

    underscore(value: string){
        let ris = value;
        ris = ris.replaceAll(", ", "_");
        ris = ris.replaceAll(" ", "_");
        ris = ris.replaceAll("-", "_");
        ris = ris.replaceAll(",", "_");
        ris = ris.replaceAll("'", "_");
        ris = ris.replaceAll(".", "");
        return ris;
    },
    
    async getFormattedMediaDuration(url: string): Promise<string | null> {
        const type = getTypeFromUrl(url)

        if (type !== VM.AttachmentType.Video && type !== VM.AttachmentType.Audio) {
            return null // Solo per video o audio
        }

        return new Promise((resolve, reject) => {
            const media = document.createElement(type === VM.AttachmentType.Video ? 'video' : 'audio')
            media.src = url
            media.preload = 'metadata'

            media.addEventListener('loadedmetadata', () => {
                const duration = media.duration
                if (!isNaN(duration)) {
                    const formatted = this.academyDuration(duration)
                    resolve(formatted)
                } else {
                    resolve(null)
                }
            })

            media.addEventListener('error', () => {
                resolve(null)
            })
        })
    }
}

export default filters;

declare module '@vue/runtime-core' {
    export interface ComponentCustomProperties {
        $filters: typeof filters;
    }
}
  